/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import MeasureType, { MeasureTypeStrings } from 'enums/MeasureType'
import { MetricItem } from 'enums/MetricItem'

/* eslint-disable import/prefer-default-export */
export const getChildTypes = (
  viewOption: InsightViewOptionStrings,
  measureType: MeasureTypeStrings
) => {
  switch (viewOption) {
    case InsightViewOption.OWNED_PARTNERED_EARNED:
      return MetricItem.CHILDREN_OPE
    case InsightViewOption.CHANNELS:
      return MetricItem.CHILDREN_CHANNELS
    case InsightViewOption.STAR_RATINGS:
      return MetricItem.CHILDREN_STAR_RATING
    case InsightViewOption.SURVEY_SCORES:
      return MetricItem.CHILDREN_SURVEY_SCORE
    case InsightViewOption.OVERVIEW:
      switch (measureType) {
        case MeasureType.POSTS:
          return [MeasureType.POST_VIDEOS, MeasureType.POST_IMAGES, MeasureType.POST_OTHER]
        case MeasureType.NET_SENTIMENT:
          return [MeasureType.POSITIVES, MeasureType.NEGATIVES]
        case MeasureType.ENGAGEMENTS:
          return [
            MeasureType.COMMENTS,
            MeasureType.LIKES,
            MeasureType.SHARES,
            MeasureType.VIEWS,
            MeasureType.SCORE
          ]
        case MeasureType.OVERALL_STAR_RATINGS:
        case MeasureType.STAR_RATINGS:
          return MetricItem.CHILDREN_STAR_RATING
        case MeasureType.OVERALL_SURVEY_SCORES:
        case MeasureType.SURVEY_SCORES:
          return MetricItem.CHILDREN_SURVEY_SCORE
        case MeasureType.NET_PROMOTER_SCORES:
          return MetricItem.CHILDREN_NET_PROMOTER_SCORE
        case MeasureType.IMPRESSIONS:
        case MeasureType.PASSION_INTENSITY:
        case MeasureType.ENGAGEMENT_RATIO:
        case MeasureType.MENTIONS:
        case MeasureType.UNIQUE_AUTHORS:
        default:
          return []
      }
    default:
      return []
  }
}
